// Sign-in errors the form treats specially. Browser-safe: the server throws
// them (lib/auth/credentials.js) and SignInForm recognises them.
export const TEMPORARY_PASSWORD_EXPIRED =
  "That temporary password has expired. Temporary passwords work for 30 days. Reset your password by email to get back in.";
